import Reflux from 'reflux';
import { fromJS, Map } from 'immutable';
import AlertBarActions from 'flux/actions/AlertBarActions';
import BaseMixin from 'flux/stores/BaseMixin';

/**
 * AlertStore
 *
 * Keeps track of alert visibility
 *
 */
export default Reflux.createStore({
  listenables: [AlertBarActions],

  mixins: [BaseMixin],

  init() {
    this.setState(
      Map({
        containers: true,
      }),
    );
  },

  /**
   * Config is expected to have the following shape:
   *
   * {
      message: "We've successfully restored your item!",
      linkText: "Go there now!",
      linkAction,
      type: "success",
      dismissible: true,
      autoDismissAfter: 10000
    }
   *
   */
  onShow(cfg) {
    this.mergeStateAndTrigger(fromJS(cfg));

    if (cfg.autoDismissAfter) {
      setTimeout(() => AlertBarActions.hide(), cfg.autoDismissAfter);
    }
  },

  onHide() {
    let next = Map({});

    next = next.set('containers', this.getInState('containers'));

    this.setStateAndTrigger(next);
  },
});
